"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { CategoryOption } from "@/components/SearchFilters";

interface CategoryFilterChipsProps {
  categories: CategoryOption[];
  activeCategory?: string;
  activeQ?: string;
}

function buildHref(category?: string, q?: string) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  if (category) params.set("category", category);
  const qs = params.toString();
  return `/search${qs ? `?${qs}` : ""}`;
}

export function SkillFilterChips({ categories, activeCategory, activeQ }: CategoryFilterChipsProps) {
  const t = useTranslations("search");
  if (categories.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {/* "All" chip */}
      <Link
        href={buildHref(undefined, activeQ) as "/search"}
        className="inline-flex items-center rounded-full border px-4 py-1.5 text-sm font-medium transition-colors hover:opacity-80"
        style={
          !activeCategory
            ? {
                background: "var(--color-brand)",
                borderColor: "var(--color-brand)",
                color: "#fff",
              }
            : {
                background: "var(--color-surface, var(--color-bg))",
                borderColor: "var(--color-border)",
                color: "var(--color-text)",
              }
        }
      >
        {t("all")}
      </Link>

      {categories.map((cat) => {
        const isActive = cat.id === activeCategory;
        return (
          <Link
            key={cat.id}
            href={buildHref(cat.id, activeQ) as "/search"}
            className="inline-flex items-center rounded-full border px-4 py-1.5 text-sm font-medium transition-colors hover:opacity-80"
            style={
              isActive
                ? {
                    background: "var(--color-brand)",
                    borderColor: "var(--color-brand)",
                    color: "#fff",
                  }
                : {
                    background: "var(--color-surface, var(--color-bg))",
                    borderColor: "var(--color-border)",
                    color: "var(--color-text)",
                  }
            }
          >
            {cat.label}
          </Link>
        );
      })}
    </div>
  );
}

